/* This file is autogenerated, see readme.md for instructions */
import RunningAggregateSvgIcon from '@bloomreach/banana-theme/icons/running-aggregate.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RunningAggregateIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RunningAggregateSvgIcon />
    </Icon>
  );
});

RunningAggregateIcon.displayName = 'RunningAggregateIcon';

export default RunningAggregateIcon;
